// --------------------------------------------------------
// AGENDA MES - AgendaMes
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import AgendaMesHorarioListItem from '../../components/criarAgenda/AgendaMesHorarioListItem';
import { StyledCheckbox, StyledText } from '../../components/criarAgenda/AgendaMesHorarioListItem.styled';
import CriarAgendaHeader from '../../components/criarAgendaHeader/CriarAgendaHeader';
import GenericModal from '../../components/genericModal/GenericModal';
import ListHeader from '../../components/itemList/ListHeaders';
import { GenericSolidButton } from '../../components/UI/buttons/Button.styled';
import ContainerWithSidebar from '../../components/UI/containerWithSidebar/ContainerWithSidebar';
import { H1, TextLink } from '../../components/UI/generalLayout/Layout.styled';
import Colors from '../../constants/Colors';
import { AgendaService } from '../../core/http/service/AgendaService';
import { UnitService } from '../../core/http/service/UnitService';
import { Paths } from '../../enums/Paths';
import AgendaMesDia from '../../models/core/agenda/AgendaMesDia';
import Unit from '../../models/core/unit/Unit';
import BaseResponse from '../../models/core/BaseResponse';
import { CompanyListContainer } from '../company/CompanyList.styled';
import { GeneralContainer } from '../home/Home.styled';
import { ReactComponent as Block } from '../../assets/imgs/protectionLock.svg'
import { ReactComponent as TrashBin } from '../../assets/imgs/trashBin.svg'
import * as agendaActions from '../../store/actions/agenda';
import { useAppDispatch } from '../..';
import { handleBackendErrors } from '../../helpers/HelperFunctions';
import useResponsiveInfo from '../../hooks/useResponsiveInfo';

// --------------------------------------------------------
// AGENDA MES INTERFACE
// --------------------------------------------------------
/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */
function AgendaMes(): JSX.Element {
    // --------------------------------------------------------
    // AGENDA MES PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const [agendasMesHeaderFields] = useState([{ name: 'Data', width: '10%', align: null }, { name: 'Horário', width: '10%', align: null }, { name: 'Unidade', width: '12%', align: 'left' }, { name: 'Clínico/Periódico/Preventivo', width: '20%', align: 'left' }, { name: 'Agenda', width: '12%', align: 'left' }, { name: 'Ações', width: '5%', align: 'left' }])
    const [turnosDia, setTurnosDia] = useState<any[]>([])
    const [isAllSelectedCheckbox, setIsAllSelectedCheckbox] = useState(false)
    const [showModalInactivateAll, setShowModalInactivateAll] = useState(false)
    const [isBlockAllAction, setIsBlockAllAction] = useState(false)
    const [isDeleteAllAction, setIsDeleteAllAction] = useState(false)
    const [selectedAgendasList, setSelectedAgendasList] = useState<any[]>([])
    const [generalErrors, setGeneralErrors] = useState<any[]>([])
    const [activeCount, setActiveCount] = useState<number>(0)
    const [isSelectedButtonsDisabled, setIsSelectedButtonsDisabled] = useState<boolean>(false)
    const { isMobile } = useResponsiveInfo();
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { state }: any = useLocation();
    const { mesFormatado, agenda, profissionalInfo } = state;
    const [unidade, setUnidade] = useState<any>(agenda.unidade?.[0] || null)

    const fetchAgendaDia = useCallback(async () => {
        const retorno: AgendaMesDia[] = [];
        let activeCount: number = 0;
        const service: AgendaService = new AgendaService();
        const params = {
            profissionalId: profissionalInfo.id,
            perfilSaude: profissionalInfo.perfilSaude,
            unidadeAtendimentoId: agenda.unidadeAtendimentoId,
            data: agenda.data
        }

        if (!unidade) {
            const unitService = new UnitService();
            const unitResponse: any = await unitService.getUnitById(agenda.unidadeAtendimentoId);
            setUnidade(new Unit().fromJSON(unitResponse.data.data));
        }

        const response: any = await service.getAgendasProfissionalDia(params)
        const baseResponse: any = new BaseResponse<any>().fromJSON(response.data)
        baseResponse.data.forEach((d: any) => {
            if(!d.inativo){
                activeCount++;
            }
            const obj = new AgendaMesDia().fromJSON(
                {
                    ...d,
                    data: moment.utc(d.data).format('DD/MM/YYYY'),
                    horaInicio: d.horaInicio.substring(0, 5),
                    horaFim: d.horaFim.substring(0, 5),
                    unit: unidade
                })
            retorno.push(obj)
        })

        setTurnosDia(retorno)
        setActiveCount(activeCount)

    }, [agenda, profissionalInfo, unidade])

    useEffect(() => {
        fetchAgendaDia()
    }, [agenda, profissionalInfo])

    useEffect(() => {
        if(selectedAgendasList.length === 0){
            setIsSelectedButtonsDisabled(true)
        }else{
            setIsSelectedButtonsDisabled(false)
        }
    }, [selectedAgendasList])

    const addAllToList = () => {
        if (selectedAgendasList.length === turnosDia.length || selectedAgendasList.length === activeCount) {
            setIsAllSelectedCheckbox(false)
            setSelectedAgendasList([])
        } else {
            setIsAllSelectedCheckbox(true)
            turnosDia.forEach(agenda => {
                setSelectedAgendasList((prev: any) => {
                    const list = [...prev]
                    const index = list.findIndex((element: any) => {
                        return element.turnoDiaId === agenda.turnoDiaId
                    })

                    index === -1 && !agenda.inativo && agenda.ativavel && list.push(agenda)
                    return list;
                })
            })
        }
    }

    const addAgendaToList = (data: any) => {
        setSelectedAgendasList((prev: any) => {
            const list = [...prev]
            const index = list.findIndex((element: any) => {
                return element.turnoDiaId === data.turnoDiaId
            })

            index === -1 ? list.push(data) : list.splice(index, 1)
            return list;
        })
    }

    const isAgendaOnList = (data: any) => {
        const agendaOnList = selectedAgendasList.filter(p => {
            return p.turnoDiaId === data.turnoDiaId;
        })

        return agendaOnList.length > 0;
    }

    const onBlockSelectedClick = () => {
        if (selectedAgendasList.length > 0) {
            setIsBlockAllAction(true);
            setIsDeleteAllAction(false);
            setShowModalInactivateAll(true)
        }
    }

    const blockSelected = async ()=>{
        selectedAgendasList.forEach(async a=>{
            try{
                await dispatch(agendaActions.activateOrDeactivateAgendaTurnoDia(a.agendaId, a.turnoDiaId, a.inativo))
                fetchAgendaDia()
            }catch(error: any){
                handleBackendErrors(error, setGeneralErrors)
            }
        })
        setShowModalInactivateAll(false)
        setIsAllSelectedCheckbox(false)
        setSelectedAgendasList([])
    }

    const onDeleteSelectedClick = () => {
        if (selectedAgendasList.length > 0) {
            setIsBlockAllAction(false);
            setIsDeleteAllAction(true);
            setShowModalInactivateAll(true)
        }
    }

    const deleteSelected = ()=>{
        selectedAgendasList.forEach(async a=>{
            try{
                await dispatch(agendaActions.deleteAgendaTurnoDia(a.agendaId, a.turnoDiaId))
                fetchAgendaDia()
            }catch(error: any){
                handleBackendErrors(error, setGeneralErrors)
            }
        })
        setShowModalInactivateAll(false)
        setIsAllSelectedCheckbox(false)
        setSelectedAgendasList([])
    }

    const goBackToProfessionalSchedule = () => {
        return navigate(Paths.Agendas, { state: { agenda: profissionalInfo, nome: profissionalInfo.nome } })
    }

    const activateInactivateAgendaMesHorario = async (agendaId: string, turnoDiaId: string, isActivate: boolean) => {
        try{
            await dispatch(agendaActions.activateOrDeactivateAgendaTurnoDia(agendaId, turnoDiaId, isActivate))
            fetchAgendaDia()
        }catch(error: any){
            handleBackendErrors(error, setGeneralErrors)
        }
    }

    const deleteAgendaTurnoDia = async (agendaId: string, turnoDiaId: string) => {
        try{
            await dispatch(agendaActions.deleteAgendaTurnoDia(agendaId, turnoDiaId))
            fetchAgendaDia()
        }catch(error: any){
            handleBackendErrors(error, setGeneralErrors)
        }
    }

    const mountModalMsg = () => {
        return 'Tem certeza que deseja ' + (isBlockAllAction ? 'bloquear' : 'excluir') + ' todas as agendas selecionadas?'
    }


    return <ContainerWithSidebar>
        <GeneralContainer>
            <TextLink color={Colors.SPM600} onClick={goBackToProfessionalSchedule}>{'< Voltar para a agenda do profissional'}</TextLink>
            <CriarAgendaHeader nome={profissionalInfo.nome} agenda={profissionalInfo} errors={generalErrors} onCloseError={()=>{setGeneralErrors([])}}/>
            <div style={{ flexDirection: isMobile? 'column':'row', paddingLeft: isMobile? 10 : 0, paddingRight: isMobile? 10:0, display: 'flex', justifyContent: 'space-between' }}>
                <H1>{mesFormatado ?? ''}</H1>
                <div style={{ flexDirection: 'row', display: 'flex', justifyContent:'space-between' }}>
                    {isMobile && (<GenericSolidButton color={Colors.SPM600} disabled={isSelectedButtonsDisabled} style={{ marginRight: 5 }} onClick={onBlockSelectedClick}>Bloquear selecionados</GenericSolidButton>)}
                    {isMobile && (<GenericSolidButton color={Colors.error} disabled={isSelectedButtonsDisabled} onClick={onDeleteSelectedClick}>Excluir selecionados</GenericSolidButton>)}

                    {!isMobile && (<>
                        <div>
                            <GenericSolidButton color={Colors.SPM600} disabled={isSelectedButtonsDisabled} onClick={onBlockSelectedClick}>Bloquear selecionados</GenericSolidButton>
                        </div>
                        <div style={{ marginLeft: 10 }}>
                            <GenericSolidButton color={Colors.error} disabled={isSelectedButtonsDisabled} onClick={onDeleteSelectedClick}>Excluir selecionados</GenericSolidButton>
                        </div>
                    </>)}
                </div>
            </div>

            <div>
                <div style={{ flexDirection: 'row', display: 'flex', width: '100%' }}>
                    <StyledCheckbox checked={isAllSelectedCheckbox} onChange={addAllToList} />
                    <div style={{ width: '100%' }}>
                        {!isMobile ? (<ListHeader fields={agendasMesHeaderFields} />):(<StyledText>Selecione todos</StyledText>)}
                    </div>
                </div>
                <CompanyListContainer>
                    {turnosDia.map((turnoDia: any, index: number) => {
                        return <AgendaMesHorarioListItem
                            key={index}
                            profissionalInfo={profissionalInfo}
                            addObjectToSelectedList={() => { addAgendaToList(turnoDia); } }
                            isOnSelectedList={isAgendaOnList(turnoDia)}
                            agenda={agenda}
                            data={turnoDia}
                            nome={profissionalInfo.nome}
                            activateInactivateAgendaMesHorario={activateInactivateAgendaMesHorario}
                            activateInactivateAgendaMesDiaHorario={() => { } } 
                            deleteAgendaTurnoDia={deleteAgendaTurnoDia} 
                            deleteAgendaTurnoDiaHorario={()=>{}}                        />
                    })}
                </CompanyListContainer>

            </div>

            <GenericModal
                visible={showModalInactivateAll}
                Icon={() => { return isBlockAllAction ? <Block width="120" height="120" /> : <TrashBin width="120" height="120" /> }}
                onCancel={isBlockAllAction? async ()=>{ await blockSelected(); } : async () => { await deleteSelected() }}
                onConfirm={() => { setShowModalInactivateAll(false) }}
                modalTitle={mountModalMsg()}
                modalSubtitle={''}
                cancelButtonMsg={'Voltar'}
                confirmButtonMsg={isBlockAllAction ? 'Bloquear' : 'Excluir'}
            />
        </GeneralContainer>
    </ContainerWithSidebar>;
}

export default AgendaMes;
